/* ===== Marigold Lane theme JS ===== */
(function(){
  var money = function(cents){
    try{
      return '$' + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }catch(e){ return '$' + (cents/100); }
  };

  function qs(s,el){return (el||document).querySelector(s);}
  function qsa(s,el){return Array.prototype.slice.call((el||document).querySelectorAll(s));}

  var overlay = qs('#mg-overlay');
  function openEl(el){ if(el){el.classList.add('on');} if(overlay){overlay.classList.add('on');} document.body.style.overflow='hidden'; }
  function closeAll(){
    qsa('.drawer').forEach(function(d){d.classList.remove('on');});
    if(overlay){overlay.classList.remove('on');}
    document.body.style.overflow='';
  }
  if(overlay){ overlay.addEventListener('click', closeAll); }
  qsa('[data-close]').forEach(function(b){ b.addEventListener('click', closeAll); });
  document.addEventListener('keyup', function(e){ if(e.key==='Escape'){ closeAll(); closeModal(); } });

  /* mobile menu */
  var burger = qs('#mg-burger'), mdrawer = qs('#mg-mobile');
  if(burger){ burger.addEventListener('click', function(){ openEl(mdrawer); }); }
  qsa('.mnav .mgroup>a').forEach(function(a){
    a.addEventListener('click', function(e){
      var sub = a.parentNode.querySelector('.msub');
      if(sub){ e.preventDefault(); sub.style.display = (sub.style.display==='flex')?'none':'flex'; }
    });
  });

  /* ===== Cart drawer ===== */
  var cartDrawer = qs('#mg-cart');
  var cartOpeners = qsa('[data-cart-open]');
  cartOpeners.forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); openEl(cartDrawer); refreshCart(); }); });

  function renderCart(cart){
    var wrap = qs('#mg-cart-items'), foot = qs('#mg-cart-foot');
    if(!wrap) return;
    updateBubble(cart.item_count);
    if(!cart.items || cart.items.length===0){
      wrap.innerHTML = '<div class="cart-empty">Your bag is empty.<br><br><a class="btn ghost" href="/collections/new-in">Shop New In</a></div>';
      if(foot) foot.innerHTML='';
      return;
    }
    var html='';
    cart.items.forEach(function(it){
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?.*)?$/i,'_160x$1$2') : '';
      html += '<div class="citem" data-key="'+it.key+'">'
        + '<a href="'+it.url+'" class="imgwrap"><img src="'+img+'" alt=""></a>'
        + '<div><a href="'+it.url+'" class="cnm">'+it.product_title+'</a>'
        + (it.variant_title && it.variant_title!=='Default Title' ? '<div class="cvar">Size '+it.variant_title+'</div>' : '')
        + '<div class="qrow"><button data-dec>&minus;</button><span>'+it.quantity+'</span><button data-inc>+</button></div></div>'
        + '<div><div class="cpr">'+money(it.final_line_price)+'</div><div class="rm" data-rm>Remove</div></div>'
        + '</div>';
    });
    wrap.innerHTML = html;
    if(foot){
      foot.innerHTML = '<div class="row"><span>Subtotal</span><span>'+money(cart.total_price)+'</span></div>'
        + '<div class="sub">Shipping &amp; taxes calculated at checkout &middot; Free AU shipping over $80</div>'
        + '<a href="/checkout" class="btn solid block">Checkout</a>'
        + '<a href="/cart" class="btn ghost block" style="margin-top:8px">View bag</a>';
    }
    bindCartControls();
  }

  function bindCartControls(){
    qsa('#mg-cart-items .citem').forEach(function(row){
      var key = row.getAttribute('data-key');
      var span = row.querySelector('.qrow span');
      var q = parseInt(span.textContent,10);
      var inc = row.querySelector('[data-inc]'), dec = row.querySelector('[data-dec]'), rm = row.querySelector('[data-rm]');
      if(inc) inc.addEventListener('click', function(){ changeQty(key, q+1); });
      if(dec) dec.addEventListener('click', function(){ changeQty(key, q-1); });
      if(rm) rm.addEventListener('click', function(){ changeQty(key, 0); });
    });
  }

  function changeQty(key, qty){
    fetch('/cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:key, quantity:qty})})
      .then(function(r){return r.json();}).then(renderCart);
  }

  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(renderCart);
  }

  function updateBubble(count){
    qsa('[data-cart-count]').forEach(function(b){
      b.textContent = count;
      b.style.display = count>0 ? '' : 'none';
    });
  }

  /* ===== PDP ===== */
  // gallery
  qsa('#mg-thumbs .imgwrap').forEach(function(th){
    th.addEventListener('click', function(){
      qsa('#mg-thumbs .imgwrap').forEach(function(x){x.classList.remove('active');});
      th.classList.add('active');
      var main = qs('#mg-main-img');
      if(main){ main.src = th.getAttribute('data-src'); }
    });
  });

  // size / variant selection
  var form = qs('#mg-product-form');
  if(form){
    var idInput = qs('#mg-variant-id');
    var addBtn = qs('#mg-add');
    var addLabel = qs('#mg-add-label');
    var priceEl = qs('#mg-price-amt');
    qsa('#mg-sizes .s').forEach(function(s){
      s.addEventListener('click', function(){
        if(s.classList.contains('off')) return;
        qsa('#mg-sizes .s').forEach(function(x){x.classList.remove('on');});
        s.classList.add('on');
        if(idInput) idInput.value = s.getAttribute('data-vid');
        var avail = s.getAttribute('data-available')==='true';
        if(addBtn){
          addBtn.disabled = !avail;
          if(addLabel){ addLabel.textContent = avail ? ('Add to bag — '+ (priceEl?priceEl.textContent:'')) : 'Sold out'; }
        }
      });
    });
    form.addEventListener('submit', function(e){
      e.preventDefault();
      if(!idInput || !idInput.value){ flash('Please choose a size.'); return; }
      var body = {items:[{id: parseInt(idInput.value,10), quantity:1}]};
      if(addBtn){ addBtn.disabled=true; }
      fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify(body)})
        .then(function(r){ return r.json().then(function(d){ return {ok:r.ok, d:d}; }); })
        .then(function(res){
          if(addBtn){ addBtn.disabled=false; }
          if(!res.ok){ flash(res.d.description || 'Could not add to bag.'); return; }
          openEl(cartDrawer); refreshCart();
        }).catch(function(){ if(addBtn){addBtn.disabled=false;} flash('Something went wrong.'); });
    });
  }
  function flash(msg){
    var n = qs('#mg-form-note');
    if(n){ n.textContent = msg; }
  }

  /* size chart modal */
  var modal = qs('#mg-size-modal');
  qsa('[data-sizeguide]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); if(modal){ modal.classList.add('on'); document.body.style.overflow='hidden'; } }); });
  function closeModal(){ if(modal){ modal.classList.remove('on'); if(!qs('.drawer.on')) document.body.style.overflow=''; } }
  window._mgCloseModal = closeModal;
  qsa('[data-modal-close]').forEach(function(b){ b.addEventListener('click', closeModal); });
  if(modal){ modal.addEventListener('click', function(e){ if(e.target===modal) closeModal(); }); }

  /* init cart bubble on load */
  refreshCart();
})();
